import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massDestroyClients } from "../../api/apiClients";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي للعملاء (soft delete)
 */
export function useDeleteAllClients() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllClientsMutate,
        isPending,
    } = useMutation({
        mutationFn: massDestroyClients,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["clients"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete clients");
        },
    });

    return {
        deleteAllClientsMutate,
        isPending,
    };
}